import { useEffect, useState } from "react";
import "./mobileHeader.css";

// Fills the space between AppShell's floating hamburger (top-left) and notification bell
// (top-right) on Mobile with the current screen's title + optional secondary content, instead
// of leaving it empty with page content starting well below. Mobile-only — hidden at >=768px
// via CSS, so it renders nothing on Tablet/Desktop and those screens' own existing
// headers/toolbars there are completely untouched.
//
// `title` is always shown, vertically centered against the 44px floating buttons. `subtitle`
// (optional) renders as a small, secondary line directly under it — e.g. Members' member count.
// `children` (optional) renders as a further row below that — e.g. Termini's date-nav — kept
// compact, no extra spacing beyond what the content itself needs.
//
// `onTitleClick` (optional) makes the title itself interactive — e.g. Calendar's title opens a
// "jump to month" popup — without changing anything for the screens that don't pass it (title
// stays a plain, inert heading there).
//
// Only visible while at the very top of the page — since this is `position:fixed`, it would
// otherwise stay pinned on screen for the entire scroll, permanently covering whatever content
// scrolls up underneath it. These pages all scroll at the window/document level (no internal
// `overflow` container), so a plain window scroll listener covers every screen this renders on.
const MobileHeader = ({ title, subtitle, children, onTitleClick }) => {
  const [scrolled, setScrolled] = useState(
    typeof window !== "undefined" ? window.scrollY > 4 : false
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`hf-mhdr${scrolled ? " hf-mhdr-scrolled" : ""}`}>
      {onTitleClick ? (
        <button
          type="button"
          className="hf-mhdr-title hf-mhdr-title-btn"
          onClick={onTitleClick}
        >
          {title}
        </button>
      ) : (
        <h1 className="hf-mhdr-title">{title}</h1>
      )}
      {subtitle && <p className="hf-mhdr-subtitle">{subtitle}</p>}
      {children && <div className="hf-mhdr-extra">{children}</div>}
    </div>
  );
};

export default MobileHeader;
